
import { Component } from '@angular/core';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { cardOutline, cardSharp, cashOutline, cashSharp, chatbubblesOutline, locateOutline, locateSharp, listOutline, listSharp, mapOutline, mapSharp,
  chatbubblesSharp, happyOutline, sadOutline, sadSharp, happySharp, peopleOutline, peopleSharp ,schoolOutline, schoolSharp, navigateOutline, navigateSharp, carOutline, carSharp,
  gridOutline, gridSharp, calendarOutline, calendarSharp, settingsOutline, settingsSharp,
  personCircleOutline, personCircleSharp, helpCircleOutline, helpCircleSharp } from 'ionicons/icons';
import { LanguageService } from './services/language.service';
import { AuthService } from './services/auth.service';
import { PushNotificationService } from './services/push-notification.service';
import { OrgFeaturesService } from './services/org-features.service';
import { UiV2Service } from './v2/ui-v2.service';
import { V2ThemeService } from './v2/ui/v2-theme.service';
import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import { SetupGuideWidgetComponent } from './shared/setup-guide-widget/setup-guide-widget.component';
import { PaymentsGuideWidgetComponent } from './shared/payments-guide-widget/payments-guide-widget.component';

  import '@capacitor/camera';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  imports: [IonApp, IonRouterOutlet, SetupGuideWidgetComponent, PaymentsGuideWidgetComponent],
})
export class AppComponent {
  /** True when the v2 redesign is on. */
  v2On = false;

  constructor(
    private languageService: LanguageService,
    private auth: AuthService,
    private pushService: PushNotificationService,
    private orgFeatures: OrgFeaturesService,
    uiV2: UiV2Service,
    v2Theme: V2ThemeService,
  ) {
    uiV2.init();
    if (uiV2.isEnabled()) v2Theme.init();
    this.v2On = uiV2.isEnabled();
    addIcons({ mapOutline, mapSharp, locateOutline, locateSharp, listOutline, listSharp, sadOutline, sadSharp, cardOutline, cardSharp, cashOutline, cashSharp, chatbubblesOutline, chatbubblesSharp, happyOutline, happySharp, peopleOutline, peopleSharp, schoolOutline, schoolSharp,
      navigateOutline, navigateSharp, carOutline, carSharp, gridOutline, gridSharp, calendarOutline, calendarSharp, settingsOutline, settingsSharp,
      personCircleOutline, personCircleSharp, helpCircleOutline, helpCircleSharp });
    this.initStatusBar();
    this.watchUser();
  }

  private watchUser(): void {
    this.auth.currentUser$.subscribe(user => {
      if (user) {
        this.pushService.init();
        this.orgFeatures.load().subscribe();
      } else {
        this.pushService.cleanup();
      }
    });
  }

  private async initStatusBar() {
    if (Capacitor.isNativePlatform()) {
      await StatusBar.setOverlaysWebView({ overlay: false });
      await StatusBar.setStyle({ style: Style.Light });
      await StatusBar.setBackgroundColor({ color: '#ffffff' });
    }
  }
}
